import {
  CHECK_IF_LOGGED_IN_BEGIN,
  CHECK_IF_LOGGED_IN,
  CHECK_IF_LOGGED_IN_FAILURE,
  CHECK_IF_HAS_SUBSCRIPTION_BEGIN,
  CHECK_IF_HAS_SUBSCRIPTION,
  CHECK_IF_HAS_SUBSCRIPTION_FAILURE,
  ADD_IMPORT,
} from 'constants/actionTypes';

const initialState = {
  hasLoadedIsLoggedIn: false,
  isLoggedIn: false,
  hasLoadedHasSubscription: false,
  hasSubscription: false,
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case CHECK_IF_LOGGED_IN_BEGIN: {
      return {
        ...state,
        hasLoadedIsLoggedIn: false,
        isLoggedIn: false,
      };
    }
    case CHECK_IF_LOGGED_IN: {
      const { isLoggedIn } = action.payload.data;
      return {
        ...state,
        hasLoadedIsLoggedIn: true,
        isLoggedIn,
      };
    }
    case CHECK_IF_LOGGED_IN_FAILURE: {
      return {
        ...state,
        hasLoadedIsLoggedIn: true,
        isLoggedIn: false,
      };
    }
    case CHECK_IF_HAS_SUBSCRIPTION_BEGIN: {
      return {
        ...state,
        hasLoadedHasSubscription: false,
        hasSubscription: false,
      };
    }
    case CHECK_IF_HAS_SUBSCRIPTION: {
      const { hasSubscription } = action.payload.data;
      return {
        ...state,
        hasLoadedHasSubscription: true,
        hasSubscription,
      };
    }
    case CHECK_IF_HAS_SUBSCRIPTION_FAILURE: {
      return {
        ...state,
        hasLoadedHasSubscription: true,
        hasSubscription: false,
      };
    }
    case ADD_IMPORT: {
      const { message } = action.payload.data;
      if (message === 'NotLoggedIn') {
        return {
          ...state,
          hasLoadedIsLoggedIn: true,
          isLoggedIn: false,
        };
      }
      return state;
    }
    default:
      return state;
  }
}
